module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.04af9a9.ttf";